// @flow
import { transparentize } from 'polished';
import styled from 'styled-components';

export const Opacity = styled.g`opacity: 0;`;

export const Container = styled.g`cursor: pointer;`;

export const ClickableArea = styled.rect`fill: transparent;`;

export const Background = styled.circle`
    fill: ${p => transparentize(0.2, p.theme.lightGrey)};
    stroke: ${p => p.theme.heavyGrey};
    stroke-dasharray: 3, 3;
    stroke-width: 2;
`;

export const Line = styled.path`
    fill: transparent;
    stroke: ${p => p.theme.heavyGrey};
    stroke-width: 2;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/day/add-event-button/style.js